import { FC, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { LoginByGuid } from "./login-by-guid";

export const GuidByUrl: FC = () => {
  const navigation = useNavigate();
  let { guid } = useParams();

  useEffect(() => {
    if (!guid) {
      navigation("/");
    }
  }, [guid, navigation]);

  return guid ? <LoginByGuid guid={guid} /> : null;
};
